export const BASE_CURRENCIES = [
  // most popular currencies
  { label: 'None', value: '' },
  { label: 'EUR', value: 'EUR' }, // Euro
  { label: 'USD', value: 'USD' }, // US Dollar
  { label: 'GBP', value: 'GBP' }, // British Pound
  { label: 'CAD', value: 'CAD' }, // Canadian Dollar
  { label: 'AUD', value: 'AUD' }, // Australian Dollar
  { label: 'CHF', value: 'CHF' }, // Swiss Franc
  { label: 'JPY', value: 'JPY' }, // Japanese Yen
  { label: 'CNY', value: 'CNY' }, // Chinese Yuan
  { label: 'INR', value: 'INR' }, // Indian Rupee
  { label: 'SGD', value: 'SGD' }, // Singapore Dollar
  { label: 'KRW', value: 'KRW' }, // South Korean Won
  { label: 'MXN', value: 'MXN' }, // Mexican Peso
  { label: 'HKD', value: 'HKD' }, // Hong Kong Dollar
  // Other currencies
  { label: 'BGN', value: 'BGN' },
  { label: 'BRL', value: 'BRL' },
  { label: 'CZK', value: 'CZK' },
  { label: 'DKK', value: 'DKK' },
  { label: 'HUF', value: 'HUF' },
  { label: 'IDR', value: 'IDR' },
  { label: 'ILS', value: 'ILS' },
  { label: 'ISK', value: 'ISK' },
  { label: 'MYR', value: 'MYR' },
  { label: 'NOK', value: 'NOK' },
  { label: 'NZD', value: 'NZD' },
  { label: 'PHP', value: 'PHP' },
  { label: 'PLN', value: 'PLN' },
  { label: 'RON', value: 'RON' },
  { label: 'SEK', value: 'SEK' },
  { label: 'THB', value: 'THB' },
  { label: 'TRY', value: 'TRY' },
  { label: 'ZAR', value: 'ZAR' }
  // { label: 'UZS', value: 'UZS' }
];

export { FORMPF_NUMERIC_TO_ISO } from '../../../../../../../consts/formPFCurrencies';

// Form PF currencies — value is ISO 3-letter code (unique), label is "ISO - Description"
export const BASE_CURRENCIES_FORMPF = [
  { value: 'USD', label: 'USD - United States Dollar' },
  { value: 'AFN', label: 'AFN - Afghanistan Afghani' },
  { value: 'ALL', label: 'ALL - Albanian Lek' },
  { value: 'DZD', label: 'DZD - Algerian Dinar' },
  { value: 'ADP', label: 'ADP - Andorran Peseta' },
  { value: 'AOA', label: 'AOA - Angolan Kwanza' },
  { value: 'XCD', label: 'XCD - East Caribbean Dollar' },
  { value: 'AUD', label: 'AUD - Australian Dollar' },
  { value: 'ARS', label: 'ARS - Argentine Peso' },
  { value: 'AMD', label: 'AMD - Armenian Dram' },
  { value: 'AWG', label: 'AWG - Aruban Guilder' },
  { value: 'ATS', label: 'ATS - Austrian Schilling' },
  { value: 'AZN', label: 'AZN - Azerbaijani New Manat' },
  { value: 'BSD', label: 'BSD - Bahamas Dollar' },
  { value: 'BHD', label: 'BHD - Bahraini Dinar' },
  { value: 'BDT', label: 'BDT - Bangladesh Taka' },
  { value: 'BBD', label: 'BBD - Barbadian Dollar' },
  { value: 'BYN', label: 'BYN - Belarusian Ruble' },
  { value: 'BEF', label: 'BEF - Belgian Franc' },
  { value: 'BZD', label: 'BZD - Belizean Dollar' },
  { value: 'XOF', label: 'XOF - CFA Franc BCEAO' },
  { value: 'BMD', label: 'BMD - Bermudian Dollar' },
  { value: 'BTN', label: 'BTN - Bhutan Ngultrum' },
  { value: 'BOB', label: 'BOB - Bolivian Boliviano' },
  { value: 'BAM', label: 'BAM - Bosnia & Herzegovinan Marka' },
  { value: 'BWP', label: 'BWP - Botswanan Pula' },
  { value: 'BRL', label: 'BRL - Brazilian Real' },
  { value: 'GBP', label: 'GBP - British Pound' },
  { value: 'BND', label: 'BND - Brunei Dollar' },
  { value: 'BGN', label: 'BGN - Bulgarian Lev' },
  { value: 'BIF', label: 'BIF - Burundi Franc' },
  { value: 'KHR', label: 'KHR - Cambodian Riel' },
  { value: 'XAF', label: 'XAF - CFA Franc BEAC' },
  { value: 'CAD', label: 'CAD - Canadian Dollar' },
  { value: 'CVE', label: 'CVE - Cape Verde Escudo' },
  { value: 'KYD', label: 'KYD - Cayman Islands Dollar' },
  { value: 'CLP', label: 'CLP - Chilean Peso' },
  { value: 'CNY', label: 'CNY - Chinese Renminbi' },
  { value: 'COP', label: 'COP - Columbian Peso' },
  { value: 'KMF', label: 'KMF - Comoran Franc' },
  { value: 'CDF', label: 'CDF - Congolese Franc' },
  { value: 'NZD', label: 'NZD - New Zealand Dollar' },
  { value: 'CRC', label: 'CRC - Costa Rican Colon' },
  { value: 'HRK', label: 'HRK - Croatian Kuna' },
  { value: 'CUP', label: 'CUP - Cuban Peso' },
  { value: 'CYP', label: 'CYP - Cypriot Pound' },
  { value: 'CZK', label: 'CZK - Czech Koruna' },
  { value: 'DKK', label: 'DKK - Danish Krone' },
  { value: 'DJF', label: 'DJF - Djiboutian Franc' },
  { value: 'DOP', label: 'DOP - Dominican Republic Peso' },
  { value: 'ECS', label: 'ECS - Ecuadorean Sucre' },
  { value: 'EGP', label: 'EGP - Egyptian Pound' },
  { value: 'SVC', label: 'SVC - El Salvador Colon' },
  { value: 'ERN', label: 'ERN - Eritrean Nakfa' },
  { value: 'EEK', label: 'EEK - Estonian Kroon' },
  { value: 'ETB', label: 'ETB - Ethiopian Birr' },
  { value: 'EUR', label: 'EUR - Euro' },
  { value: 'FKP', label: 'FKP - Falkland Islands Pound' },
  { value: 'FJD', label: 'FJD - Fijian Dollar' },
  { value: 'FIM', label: 'FIM - Finnish Markka' },
  { value: 'FRF', label: 'FRF - French Franc' },
  { value: 'XPF', label: 'XPF - French Polynesian Franc' },
  { value: 'GMD', label: 'GMD - Gambian Dalasi' },
  { value: 'GEL', label: 'GEL - Georgian Lari' },
  { value: 'DEM', label: 'DEM - German Mark' },
  { value: 'GIP', label: 'GIP - Gibraltar Pound' },
  { value: 'GRD', label: 'GRD - Greek Drachma' },
  { value: 'GTQ', label: 'GTQ - Guatemalan Quetzal' },
  { value: 'GGP', label: 'GGP - Guernsey Pound' },
  { value: 'GNF', label: 'GNF - Guinean Franc' },
  { value: 'GYD', label: 'GYD - Guyanese Dollar' },
  { value: 'HTG', label: 'HTG - Haitian Gourde' },
  { value: 'HNL', label: 'HNL - Honduras Lempira' },
  { value: 'HKD', label: 'HKD - Hong Kong Dollar' },
  { value: 'HUF', label: 'HUF - Hungarian Forint' },
  { value: 'ISK', label: 'ISK - Iceland Krona' },
  { value: 'INR', label: 'INR - Indian Rupee' },
  { value: 'IDR', label: 'IDR - Indonesian Rupiah' },
  { value: 'IRR', label: 'IRR - Iranian Rial' },
  { value: 'IQD', label: 'IQD - Iraqi Dinar' },
  { value: 'IEP', label: 'IEP - Irish Punt' },
  { value: 'IMP', label: 'IMP - Isle of Man Pound' },
  { value: 'ILS', label: 'ILS - Israeli Shekel' },
  { value: 'ITL', label: 'ITL - Italian Lira' },
  { value: 'JMD', label: 'JMD - Jamaican Dollar' },
  { value: 'JPY', label: 'JPY - Japanese Yen' },
  { value: 'JEP', label: 'JEP - Jersey Pound' },
  { value: 'JOD', label: 'JOD - Jordanian Dinar' },
  { value: 'KZT', label: 'KZT - Kazakhstan Tenge' },
  { value: 'KES', label: 'KES - Kenyan Shilling' },
  { value: 'KWD', label: 'KWD - Kuwaiti Dinar' },
  { value: 'KGS', label: 'KGS - Kyrgyzstan Som' },
  { value: 'LAK', label: 'LAK - Laotian Kip' },
  { value: 'LVL', label: 'LVL - Latvian Lats' },
  { value: 'LBP', label: 'LBP - Lebanese Pound' },
  { value: 'LSL', label: 'LSL - Lesotho Loti' },
  { value: 'LRD', label: 'LRD - Liberian Dollar' },
  { value: 'LYD', label: 'LYD - Libyan Dinar' },
  { value: 'CHF', label: 'CHF - Swiss Franc' },
  { value: 'LTL', label: 'LTL - Lithuanian Litas' },
  { value: 'LUF', label: 'LUF - Luxembourg Franc' },
  { value: 'MOP', label: 'MOP - Macau Pataca' },
  { value: 'MKD', label: 'MKD - Macedonian Denar' },
  { value: 'MGA', label: 'MGA - Madagascar Ariary' },
  { value: 'MWK', label: 'MWK - Malawian Kwacha' },
  { value: 'MYR', label: 'MYR - Malaysian Ringgit' },
  { value: 'MVR', label: 'MVR - Maldives Rufiyaa' },
  { value: 'MTL', label: 'MTL - Maltese Lira' },
  { value: 'MRU', label: 'MRU - Mauritanian Ouguiya' },
  { value: 'MUR', label: 'MUR - Mauritian Rupee' },
  { value: 'MXN', label: 'MXN - Mexican Peso' },
  { value: 'MDL', label: 'MDL - Moldovan Leu' },
  { value: 'MNT', label: 'MNT - Mongolian Tugrik' },
  { value: 'MAD', label: 'MAD - Moroccan Dirham' },
  { value: 'MZN', label: 'MZN - Mozambique New Metical' },
  { value: 'MMK', label: 'MMK - Myanmar Kyat' },
  { value: 'NAD', label: 'NAD - Namibian Dollar' },
  { value: 'NPR', label: 'NPR - Nepalese Rupee' },
  { value: 'NLG', label: 'NLG - Netherlands(Dutch) Guilder' },
  { value: 'ANG', label: 'ANG - Netherlands Antillean Guilder' },
  { value: 'GHS', label: 'GHS - New Ghana Cedi' },
  { value: 'SDG', label: 'SDG - New Sudanese Pound' },
  { value: 'NIO', label: 'NIO - Nicaraguan Cordoba' },
  { value: 'NGN', label: 'NGN - Nigerian Naira' },
  { value: 'KPW', label: 'KPW - North Korean Won' },
  { value: 'NOK', label: 'NOK - Norwegian Krone' },
  { value: 'CNH', label: 'CNH - Offshore Chinese Renminbi' },
  { value: 'OMR', label: 'OMR - Omani Rial' },
  { value: 'PKR', label: 'PKR - Pakistani Rupee' },
  { value: 'PAB', label: 'PAB - Panamanian Balboa' },
  { value: 'PGK', label: 'PGK - Papua New Guinea Kina' },
  { value: 'PYG', label: 'PYG - Paraguay Guarani' },
  { value: 'PEN', label: 'PEN - Peruvian New Sol' },
  { value: 'PHP', label: 'PHP - Philippine Peso' },
  { value: 'PLN', label: 'PLN - Polish Zloty' },
  { value: 'PTE', label: 'PTE - Portuguese Escudo' },
  { value: 'QAR', label: 'QAR - Qatari Rial' },
  { value: 'RON', label: 'RON - Romanian Leu' },
  { value: 'RUB', label: 'RUB - Russian Ruble' },
  { value: 'RWF', label: 'RWF - Rwandan Franc' },
  { value: 'STN', label: 'STN - Sao Tome & Principe Dobra' },
  { value: 'SAR', label: 'SAR - Saudi Riyal' },
  { value: 'RSD', label: 'RSD - Serbian Dinar' },
  { value: 'SCR', label: 'SCR - Seychelles Rupee' },
  { value: 'SLL', label: 'SLL - Sierra Leone Leone' },
  { value: 'SGD', label: 'SGD - Singapore Dollar' },
  { value: 'SKK', label: 'SKK - Slovakian Koruna' },
  { value: 'SIT', label: 'SIT - Slovenian Tolar' },
  { value: 'SBD', label: 'SBD - Solomon Islands Dollar' },
  { value: 'SOS', label: 'SOS - Somali Shilling' },
  { value: 'ZAR', label: 'ZAR - South African Rand' },
  { value: 'KRW', label: 'KRW - South Korean Won' },
  { value: 'ESP', label: 'ESP - Spanish Peseta' },
  { value: 'LKR', label: 'LKR - Sri Lankan Rupee' },
  { value: 'SHP', label: 'SHP - St.Helena Pound' },
  { value: 'SRD', label: 'SRD - Suriname Dollar' },
  { value: 'SZL', label: 'SZL - Swaziland Lilangeni' },
  { value: 'SEK', label: 'SEK - Swedish Krona' },
  { value: 'SYP', label: 'SYP - Syrian Pound' },
  { value: 'TWD', label: 'TWD - Taiwanese Dollar' },
  { value: 'TJS', label: 'TJS - Tajikistani Somoni' },
  { value: 'TZS', label: 'TZS - Tanzanian Shilling' },
  { value: 'THB', label: 'THB - Thai Baht' },
  { value: 'TOP', label: 'TOP - Tonga Pa anga' },
  { value: 'TTD', label: 'TTD - Trinidad & Tobago Dollar' },
  { value: 'TND', label: 'TND - Tunisian Dinar' },
  { value: 'TRY', label: 'TRY - Turkish New Lira' },
  { value: 'TRL', label: 'TRL - Turkish Old Lira' },
  { value: 'TMT', label: 'TMT - Turkmenistan Manat' },
  { value: 'AED', label: 'AED - UAE Dirham' },
  { value: 'UGX', label: 'UGX - Ugandan Shilling' },
  { value: 'UAH', label: 'UAH - Ukrainian Hryvnia' },
  { value: 'UYU', label: 'UYU - Uruguagyan Peso' },
  { value: 'UZS', label: 'UZS - Uzbekistani Soum' },
  { value: 'VUV', label: 'VUV - Vanuatu Vatu' },
  { value: 'VES', label: 'VES - Venezuelan Bolivar Fuerte' },
  { value: 'VND', label: 'VND - Vietnamese Dong' },
  { value: 'WST', label: 'WST - West Samoan Tala' },
  { value: 'YER', label: 'YER - Yemeni Rial' },
  { value: 'ZMW', label: 'ZMW - Zambian Kwacha' },
  { value: 'ZWL', label: 'ZWL - Zimbabwean Dollar' },
  { value: 'XXX', label: 'XXX - Other' }
];
